"use strict";
/**
 * Order Status Constants
 *
 * e.g.
 *
 * export const [variable-name] = [variable-value];
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.preorderTimeout = exports.productIdentifier = exports.subIdentifier = exports.preorderIdentifier = exports.cancelled = exports.customerCancel = exports.systemError = exports.fulfilled = exports.tenderFailed = exports.InsuranceDeductible = exports.ccCaptureMethod = exports.ccTenderType = exports.btaTenderType = exports.btaPaymentOption = exports.cardMonth = exports.paymentMethod = exports.cartUrl = exports.loginUrl = exports.invalidSSN = exports.orderNotFound = exports.dppTermEligibilityCheckUrl = exports.getProductUrl = exports.getAccountTypeUrl = exports.getPOCSubEligibilityUrl = exports.verificationStatusUrl = exports.getPreOrderEligibleDevicesUrl = exports.allStateListUrl = exports.updatePreorderTenderUrl = exports.replaceDeviceUrl = exports.getBillToAccountDetailsUrl = exports.profileCreditCardsUrl = exports.billToAccountUrl = exports.profileBillingAddressUrl = exports.cancelPreorderUrl = exports.editPreorderUrl = exports.clearCartUrl = exports.cartCountUrl = exports.validateSSNUrl = exports.preorderUrl = exports.tokenServiceErrorMsgUrl = exports.oauthTokenUrl = exports.getInsuranceUrl = exports.appleCareDetailsUrl = exports.orderDetailsUrl = exports.loginStatusUrl = void 0;
// -----------------------------------------------------------------------------
// Profile State (AccountServices)
// -----------------------------------------------------------------------------
exports.loginStatusUrl = '/global/profileController.jsp?action=getProfileState';
// -----------------------------------------------------------------------------
// Order Services (OrderServices)
// -----------------------------------------------------------------------------
exports.orderDetailsUrl = '/rest-services/web-wirelessaccount-services/v1/account/orders/';
// -----------------------------------------------------------------------------
// AppleCare/ Wireless Protection Services (OrderServices)
// -----------------------------------------------------------------------------
exports.appleCareDetailsUrl = '/rest-api/account/v1/checkAppleCareProtectionCompatibility/';
exports.getInsuranceUrl = '/rest-api/account/insurance/v2/tiers?csn=';
// -----------------------------------------------------------------------------
// Payment Token Services (OrderServices)
// -----------------------------------------------------------------------------
exports.oauthTokenUrl = '/rest-api/payment/oauth/v1/accessToken';
exports.tokenServiceErrorMsgUrl = '/resources/json/mma/tokenserviceerrormessage.json';
// -----------------------------------------------------------------------------
// Preorder Services (PreorderServices)
// -----------------------------------------------------------------------------
exports.preorderUrl = '/global/preorderController.jsp?action=getPreOrderDetails&preOrderId=';
exports.validateSSNUrl = '/rest-api/preorder/v1/validate';
exports.cartCountUrl = '/rest-api/cart/v1/itemCount';
exports.clearCartUrl = '/rest-api/cart/v1/clearCart';
exports.editPreorderUrl = '/global/preorderController.jsp?action=editPreOrderDetails';
exports.cancelPreorderUrl = '/global/preorderController.jsp?action=cancelPreOrder';
exports.profileBillingAddressUrl = '/global/preorderController.jsp?action=getProfileBillingAddr';
exports.billToAccountUrl = '/global/preorderController.jsp?action=validateBillToAccount';
exports.profileCreditCardsUrl = '/global/preorderController.jsp?action=getProfileCreditCards';
exports.getBillToAccountDetailsUrl = '/global/preorderController.jsp?action=getBillToAccountDetails';
exports.replaceDeviceUrl = '/global/preorderController.jsp?action=replacePreorderDevice';
exports.updatePreorderTenderUrl = '/global/preorderController.jsp?action=updatePreOrderTender';
exports.allStateListUrl = '/rest-api/misc/v1/states?allStates=true';
exports.getPreOrderEligibleDevicesUrl = '/global/preorderController.jsp?action=getPreOrderEligibleDevicesDetails&subId=';
exports.verificationStatusUrl = '/rest-api/preorder/v1/verification-status/';
exports.getPOCSubEligibilityUrl = '/global/preorderController.jsp?action=isEligiblePOCSub&subId=';
exports.getAccountTypeUrl = '/global/preorderController.jsp?action=getAccountType';
exports.getProductUrl = '/rest/model/atg/commerce/catalog/ProductCatalogActor/getProduct?type=phone&detailed=true&productId=';
exports.dppTermEligibilityCheckUrl = '/global/ajax_json_controller.jsp?action=dppTermEligibilityCheck';
// -----------------------------------------------------------------------------
// Order Error Messages
// -----------------------------------------------------------------------------
exports.orderNotFound = 'We can\'t display your order details at this time. Please try again later.';
exports.invalidSSN = 'We\'re sorry. The SSN provided does not match our records.';
// -----------------------------------------------------------------------------
// Login and Register URL
// -----------------------------------------------------------------------------
exports.loginUrl = '/my_account/personal/#/wireless/orders/history';
// -----------------------------------------------------------------------------
// Cart URL
// -----------------------------------------------------------------------------
exports.cartUrl = '/buy/';
// -----------------------------------------------------------------------------
// Payment Type Enum
// -----------------------------------------------------------------------------
var paymentMethod;
(function (paymentMethod) {
    paymentMethod["CREDIT_CARD"] = "Credit Card";
    paymentMethod["GIFT_CARD"] = "Gift Card";
    paymentMethod["BILL_TO_ACCOUNT"] = "Bill To Account";
})(paymentMethod = exports.paymentMethod || (exports.paymentMethod = {}));
// -----------------------------------------------------------------------------
// Payment constants
// -----------------------------------------------------------------------------
exports.cardMonth = [
    '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'
];
exports.btaPaymentOption = 'billToAccount';
exports.btaTenderType = 'BILL_TO_ACCOUNT';
exports.ccTenderType = 'CREDIT_CARD';
exports.ccCaptureMethod = 'MANUAL';
// Insurance Deductible
var InsuranceDeductible;
(function (InsuranceDeductible) {
    InsuranceDeductible["DEFAULT"] = "DEFAULT";
    InsuranceDeductible["LOST_STOLEN"] = "LOST_STOLEN";
    InsuranceDeductible["WEB_SCREEN"] = "WEB_SCREEN";
    InsuranceDeductible["IN_STORE_SCREEN"] = "IN_STORE_SCREEN";
})(InsuranceDeductible = exports.InsuranceDeductible || (exports.InsuranceDeductible = {}));
// -----------------------------------------------------------------------------
// Pre-Order Status, Identifiers and constants
// -----------------------------------------------------------------------------
exports.tenderFailed = 'TENDER_FAILED';
exports.fulfilled = 'FULFILLED';
exports.systemError = 'SYSTEM_ERROR';
exports.customerCancel = 'CUSTOMER_CANCEL';
exports.cancelled = 'CANCELED';
exports.preorderIdentifier = 'preorderId';
exports.subIdentifier = 'subId';
exports.productIdentifier = 'curDeviceId';
exports.preorderTimeout = 300000;
//# sourceMappingURL=constants.js.map